import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import Home from "@/pages/Home";
import Features from "@/pages/Features";
import Commands from "@/pages/Commands";
import Premium from "@/pages/Premium";
import Docs from "@/pages/Docs";
import Support from "@/pages/Support";
import Status from "@/pages/Status";
import Faq from "@/pages/Faq";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ServerDeletion from "@/pages/ServerDeletion";
import Dashboard from "@/pages/Dashboard";
import ServerManage from "@/pages/ServerManage";
import NotFound from "@/pages/NotFound";
import { Toaster } from "sonner";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const NormalizePath = () => {
  const location = useLocation();
  const clean = location.pathname.replace(/\/{2,}/g, "/");
  if (clean !== location.pathname) {
    return <Navigate to={`${clean}${location.search}${location.hash}`} replace />;
  }
  return null;
};

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <div className="grain min-h-screen bg-black text-paper-100">
        <ScrollToTop />
        <NormalizePath />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/features" element={<Features />} />
            <Route path="/commands" element={<Commands />} />
            <Route path="/premium" element={<Premium />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/support" element={<Support />} />
            <Route path="/status" element={<Status />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/server-deletion" element={<ServerDeletion />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/servers/:guildId" element={<ServerManage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
        <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0A0A0A", border: "1px solid rgba(255,255,255,0.12)", color: "#F5F5F5" } }} />
      </div>
    </BrowserRouter>
  );
}

export default App;
